export class Settings {
  static readonly NodeCount = 0.0002;
  static readonly LineDistance = 50;
  static readonly SpeedFactor = 1;
  static readonly ClearScreen = true;
  static readonly DominanceProbability = 0.1;
}